<template>
  <wo-region>
    <wo-layout>
      <wo-title tag-name="h3" v-t="'admin.user.createTitle'" />
    </wo-layout>
    <user-edit :value="user" @input="confirm" @cancel="confirm" />
  </wo-region>
</template>

<script>

import { User } from '@/model/identity'
import { ADMIN_USER } from '@/routes/admin'

import UserEdit from '@/components/identity/UserEdit'

export default {
  components: { UserEdit },
  data () {
    return {
      user: new User()
    }
  },
  methods: {
    confirm (user) {
      if (user) {
        this.$router.push({ name: ADMIN_USER, params: { userId: user.id } })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
